import styled from 'styled-components'

import Footnote from 'components/Typography/Footnote'
import { style } from 'theme'

export const StyledNote = styled.div`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto 80px;
  width: 350px;

  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    width: auto;
  }

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const StyledHeroHeader = styled.div`
  font-weight: bold;
  font-size: 22px;
  line-height 30px;
  margin: 30px auto 10px;
  text-align: center;
  max-width: 400px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const StyledHeroDescription = styled.div`
  font-size: 14px;
  line-height: 22px;
  width: 335px;
  margin: 0 auto 40px;
  text-align: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
    margin-bottom: 30px;
  }
`

export const FooterContainer = styled.div`
  font-size: 12px;
  line-height 16px;
  margin: 15px auto 0;
  text-align: center;
  color: ${style(theme => theme.colors.stone)};
  max-width: 340px;

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    display: none;
  }
`

export const FormItem = styled.div`
  flex-basis: 100%;
  width: 100%;
  padding-bottom: 20px;
  @media screen and (min-width: ${style(theme => theme.breakpoints.md)}px) {
    flex-basis: 50%;
  }

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    &:last-child {
      padding-bottom: 0px;
    }
  }
`

export const MobileOnlyFootnote = styled(Footnote)`
  line-height: 16px;
  text-align: center;
  padding-top: 0px;
  padding-bottom: 20px;

  @media screen and (min-width: ${style(theme => theme.breakpoints.sm + 1)}px) {
    display: none;
  }
`
